import React, { Component } from 'react'
import _ from 'lodash'
import Measure from 'react-measure'

import './styles/autoScrollView.css'

class AutoScrollView extends Component {
  constructor () {
    super()

    this.postMeasure = this.postMeasure.bind(this)
    this.scrollToTop = this.scrollToTop.bind(this)
    this.stopScrolling = this.stopScrolling.bind(this)

    this.state = {
      direction: 'down',
      top: 0,
    }
  }

  componentDidMount () {
    this.breakDelay = null
    this.intervalScroll = setInterval(this.postMeasure, this.props.speed)
  }

  componentWillReceiveProps (nextProps) {
    // When answers are cleaned
    if (this.props.childItems.length > 0 && nextProps.childItems.length === 0) {
      this.setState({ top: 0 })
    }
  }

  componentWillUnmount () {
    clearInterval(this.intervalScroll)
    clearTimeout(this.breakDelay)
  }

  invertDirection () {
    this.breakDelay = _.delay(() => {
      this.breakDelay = null
      this.setState({ direction: this.state.direction === 'up' ? 'down' : 'up' })
    }, this.props.stopDuration)
  }

  scrollToTop () {
    this.setState({
      direction: 'down',
      top: 0,
    })
  }

  stopScrolling () {
    clearInterval(this.intervalScroll)
  }

  postMeasure () {
    if (this.movableBoxDimensions && this.containerDimensions) {
      // Scrolling back to top is top priority, regardless if the movable box height is smaller than the container box.
      // This prevents the movable box from getting stuck somewhere where no child components are showing up.
      if (this.state.direction === 'up') {
        if (this.state.top < 0) {
          this.setState({ top: this.state.top + this.props.step })
        } else if (!this.breakDelay) {
          this.invertDirection()
        }
      }

      // If the movable box is smaller than the container we don't need to scroll the content
      if (this.movableBoxDimensions.height < this.containerDimensions.height) return

      // Scroll the movable box upwards until the movablebox bottom is visible
      if (this.state.direction === 'down') {
        if (this.state.top + this.movableBoxDimensions.height > this.containerDimensions.bottom - 15) {
          this.setState({ top: this.state.top - this.props.step })
        } else if (!this.breakDelay) {
          this.invertDirection()
        }
      }
    }
  }

  renderFirstAndLast (item, which) {
    return (
      <Measure
        key={item.key}
        onMeasure={(dimensions) => {
          this[which] = dimensions
        }}
      >
        {item}
      </Measure>
    )
  }

  render () {
    return (
      <Measure
        onMeasure={(dimensions) => {
          this.containerDimensions = dimensions

          this.postMeasure()
        }}
      >
        <div id="autoscrollViewContainer">
          <Measure
            onMeasure={(dimensions) => {
              this.movableBoxDimensions = dimensions

              this.postMeasure()
            }}
          >
            <div id="autoscrollMovableBox" style={{ top: this.state.top }}>
              {_.map(this.props.childItems, (child) => this.props.renderItem(child))}
            </div>
          </Measure>
        </div>
      </Measure>
    )
  }
}

AutoScrollView.defaultProps = {
  step: 1,
  speed: 30,
  stopDuration: 1000,
}

export default AutoScrollView



// WEBPACK FOOTER //
// ./src/components/common/AutoScrollView/AutoScrollView.js